import { Http } from './http';

export const GetInconsistences = (params) => Http().get(`/account?${params}`);
export const setGrouping = (body) => Http().post(`/account/grouping`, body);
